import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { O3PercentageGraphComponent } from '../components/o3-percentage-graph/o3-percentage-graph.component';

@NgModule({
    declarations: [O3PercentageGraphComponent],
    imports: [CommonModule],
    exports: [O3PercentageGraphComponent],
})
export class O3PercentageGraphModule { }
